// 사전별
export type DictArrType = {
  apiDictNm: string
  apiDictContNm: string
  viewDictNm: string
  dictKorNm: string
  apiDictSeqNm: string
  dictCd: string
  unMemberViewYn: string
  MemberViewYn: string
  fullDictKorNm?: string
  copyright?: string
}

export const dictNameArr = [
  '어린이 시사사전', // 0
  '웅진학습백과', // 1
  '용어사전', // 2
  '수학사전', // 3
  '초등학습백과', // 4
  'YBM 영한사전', // 5
  '3D백과', // 6
  '시사상식', // 7
  '역사탐방정보', // 8
  '어린이생물도감', // 9
  '식물도감', // 10
  '자연사정보', // 11
  '해양생물종정보', // 12
  // 과학학습콘텐츠(공룡, 별자리, 야생화, 곤충, 카메라)
  '공룡', // 13
  '별자리', // 14
  '야생화', // 15
  '곤충', // 16
  '카메라', // 17
  '국가기본정보', // 18
  '국어사전', // 19
  '관광사진정보', // 20
  '왕실유물정보', // 21
  '문화재정보', // 22
  '유물정보', // 23
  '궁궐종묘정보', // 24
  '우리말샘', // 25
  '미술백과', // 26
  '나눔포토', //27
]

export const dictArr: DictArrType[] = [
  {
    // 0
    apiDictNm: 'ISSUE',
    apiDictContNm: 'SEARCH_WORD_ISSUE_MEAN',
    viewDictNm: 'iss',
    dictKorNm: '어린이 시사사전',
    apiDictSeqNm: 'ISSUE_SEQ',
    dictCd: 'affair',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 1
    apiDictNm: 'WJPEDIA',
    apiDictContNm: 'SEARCH_WORD_WJPEDIA_MEAN',
    viewDictNm: 'wj',
    dictKorNm: '웅진학습백과',
    apiDictSeqNm: 'DICT_SEQ',
    dictCd: 'ECCPD',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 2
    apiDictNm: 'SMARTALL_STUDY_DIC',
    apiDictContNm: 'SEARCH_STUDYDIC_MEAN',
    viewDictNm: 'word',
    dictKorNm: '용어사전',
    apiDictSeqNm: 'DICT_SEQ',
    dictCd: 'STDDIC',
    unMemberViewYn: 'N',
    MemberViewYn: 'N',
  },
  {
    // 3
    apiDictNm: 'MATHDICT',
    apiDictContNm: 'SEARCH_WORD_MATHDICT_MEAN',
    viewDictNm: 'math',
    dictKorNm: '수학사전',
    apiDictSeqNm: 'DICT_SEQ',
    dictCd: 'MATHDICT',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 4
    apiDictNm: 'STDECC',
    apiDictContNm: 'SEARCH_STDECC_CONTENTS',
    viewDictNm: 'elem',
    dictKorNm: '초등학습백과',
    apiDictSeqNm: 'STDECPD_SEQ',
    dictCd: 'STDECC',
    unMemberViewYn: 'N',
    MemberViewYn: 'Y',
  },
  {
    // 5
    apiDictNm: 'ENG_DIC',
    apiDictContNm: 'SEARCH_WORD_ENG_MEAN',
    viewDictNm: 'eng',
    dictKorNm: '영한사전',
    apiDictSeqNm: 'SEQ_NO',
    dictCd: 'ENGDIC',
    unMemberViewYn: 'N',
    MemberViewYn: 'Y',
    fullDictKorNm: 'YBM 영한사전',
  },
  {
    // 6
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'DIC3D_CONTENTS',
    viewDictNm: 'dic3d',
    dictKorNm: '3D백과',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'DIC3D',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '쓰리디뱅크(www.3dbank.xyz)',
  },
  {
    // 7
    apiDictNm: 'SENSE',
    apiDictContNm: 'SEARCH_WORD_SENSE_MEAN',
    viewDictNm: 'eduwill',
    dictKorNm: '시사상식',
    apiDictSeqNm: 'DICT_SEQ',
    dictCd: 'SENSE',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 8
    apiDictNm: 'MODERN',
    apiDictContNm: 'SEARCH_WORD_MODERN_MEAN',
    viewDictNm: 'modern',
    dictKorNm: '역사탐방정보',
    apiDictSeqNm: 'SEARCH_CNT',
    dictCd: 'MODERN',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '',
  },
  {
    // 9
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'BIOLOGY_CONTENTS',
    viewDictNm: 'biology',
    dictKorNm: '어린이생물도감',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'BIOLOGY',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[국가생물종지식정보시스템], [http://www.nature.go.kr]',
  },
  {
    // 10
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'PLANT_CONTENTS',
    viewDictNm: 'plant',
    dictKorNm: '식물도감',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'PLANT',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright:
      '[산림청 국립수목원], [국가생물종지식정보시스템(http://www.nature.go.kr/main/Main.do)]',
  },
  {
    // 11
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'NARIS_CONTENTS',
    viewDictNm: 'natural',
    dictKorNm: '자연사정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'NARIS',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[국립중앙과학관], [국가자연사 연구종합정보 시스템(https://www.naris.go.kr)]',
  },
  {
    // 12
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'OCEANS_CONTENTS',
    viewDictNm: 'oceans',
    dictKorNm: '해양생물종정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'OCEANS',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '국립수산과학원',
  },
  {
    // 13
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'DINO_CONTENTS',
    viewDictNm: 'science',
    dictKorNm: '과학학습콘텐츠',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'DINO',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright:
      '[국립중앙과학관], [과학학습콘텐츠(https://smart.scienc e.go.kr/scienceSubject/dinosaur/list.action)]',
  },
  {
    // 14
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'CONSTELLATION_CONTENTS',
    viewDictNm: 'science',
    dictKorNm: '과학학습콘텐츠',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'CONSTELLATION',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright:
      '[국립중앙과학관], [과학학습콘텐츠(https://smart.scienc e.go.kr/scienceSubject/star/list.action)]',
  },
  {
    // 15
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'WILDFLOWER_CONTENTS',
    viewDictNm: 'science',
    dictKorNm: '과학학습콘텐츠',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'WILDFLOWER',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright:
      '[국립중앙과학관], [과학학습콘텐츠(https://smart.science.go.kr/scienceSubject/flower/list.action)]',
  },
  {
    // 16
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'INSECT_CONTENTS',
    viewDictNm: 'science',
    dictKorNm: '과학학습콘텐츠',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'INSECT',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright:
      '[국립중앙과학관], [과학학습콘텐츠(https://smart.science.go.kr/scienceSubject/bugs/list.action)]',
  },
  {
    // 17
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'CAMERA_CONTENTS',
    viewDictNm: 'science',
    dictKorNm: '과학학습콘텐츠',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'CAMERA',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright:
      '[국립중앙과학관], [과학학습콘텐츠(https://smart.science.go.kr/scienceSubject/camera/list.action)]',
  },
  {
    // 18
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'COUNTRY_CONTENTS',
    viewDictNm: 'country',
    dictKorNm: '국가기본정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'COUNTRY',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[외교부해외안전],[https://www.0404.go.kr/dev/main.mofa]',
  },
  {
    // 19
    apiDictNm: 'KOR_DIC',
    apiDictContNm: 'SEARCH_WORD_KORDIC_MEAN',
    viewDictNm: 'kor',
    dictKorNm: '국어사전',
    apiDictSeqNm: 'DICT_SEQ',
    dictCd: 'KODIC',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 20
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'VISIT_PHTG_CONTENTS',
    viewDictNm: 'sight',
    dictKorNm: '관광사진정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'VISIT_PHTG',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '사진제공 - 한국관광공사',
  },
  {
    // 21
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'ROYAL_CONTENTS',
    viewDictNm: 'royal',
    dictKorNm: '왕실유물정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'ROYAL',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 22
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'CTLHRIT_CONTENTS',
    viewDictNm: 'cultural',
    dictKorNm: '문화재정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'CTLHRIT',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[문화재청], [http://www.cha.go.kr/]',
  },
  {
    // 23
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'MUSM_CONTENTS',
    viewDictNm: 'relic',
    dictKorNm: '유물정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'MUSM',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[국립중앙박물관], [e뮤지엄(http://www.emuseum.go.kr/)]',
  },
  {
    // 24
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'JONGMYO_CONTENTS',
    viewDictNm: 'jongmyo',
    dictKorNm: '궁궐종묘정보',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'JONGMYO',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[문화재청], [http://www.cha.go.kr/]',
  },
  {
    // 25
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'KORSAM_CONTENTS',
    viewDictNm: 'woorimal',
    dictKorNm: '우리말샘',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'KOR_SAM',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },
  {
    // 26
    apiDictNm: 'PUBLIC_OPEN_DIC',
    apiDictContNm: 'ART_CONTENTS',
    viewDictNm: 'art',
    dictKorNm: '미술백과',
    apiDictSeqNm: 'DICT_UNIQ_ID',
    dictCd: 'ART',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
    copyright: '[미술백과],[워싱턴 국립 미술관]',
  }, {
    // 27
    apiDictNm: 'NANUMPHOTO',
    apiDictContNm: 'SEARCH_PHOTOLIB_CONTENTS',
    viewDictNm: 'nanumphoto',
    dictKorNm: '나눔포토',
    apiDictSeqNm: 'SEARCH_CNT',
    dictCd: 'NANUMPHOTO',
    unMemberViewYn: 'Y',
    MemberViewYn: 'Y',
  },

]
